
const validateTitle = (rule, value, callback) => {
    const regx = /^\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]$/;
    let totalNum = value ? value.length : 0
    if (totalNum > 100) {
        callback(new Error('长度不能超过60字'))
    } else if (regx.test(value)) {
        callback(new Error('不能含emoj表情'));
    } else {
        callback();
    }
}
const validateSummary = (rule, value, callback) => {
    const regx = /^\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]$/;
    let totalNum = value ? value.length : 0
    if (totalNum > 100) {
        callback(new Error('长度不能超过100字'))
    } else if (regx.test(value)) {
        callback(new Error('不能含emoj表情'));
    } else {
        callback();
    }
}
const validateSellPoint = (rule, value, callback) => {
    const regx = /^\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]$/;
    let totalNum = value ? value.length : 0
    if (totalNum > 80) {
        callback(new Error('长度不能超过80字'))
    } else if (regx.test(value)) {
        callback(new Error('不能含emoj表情'));
    } else {
        callback();
    }
}
const validateImages = async (rule, value, callback, context) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
    if (value.length < 1 || sum === 0) {
        callback(new Error('至少要选择1张图片'));
    } else if (sum > 9) {
        callback(new Error('图片数量需小于等于9张'));
    } else if (context.$refs.images) {
        let errMsg = await context.$refs.images.method_validImage()
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    } else  {
        callback()
    }
    
}

const validatePre_sale_range = async (rule, value, callback, context) => {
    if (!context.self_form.pre_sale_range || !context.self_form.pre_sale_range[0] || !context.self_form.pre_sale_range[1]) {
        return callback(new Error('请选择完整的定金支付时间'))
    }
    if (!context.self_form.balance_due_range || !context.self_form.balance_due_range[0] || !context.self_form.balance_due_range[1]) {
        return callback(new Error('请选择完整的尾款支付时间'))
    }
    callback()
}
const validateDeposit_type = async (rule, value, callback, context) => {
    if (!context.self_form.presaleParam.deposit_type && context.self_form.presaleParam.deposit_type !== 0) {
        return callback(new Error('请选择定金收取方式'))
    }
    if (context.self_form.presaleParam.deposit_type === 0 && !context.self_form.presaleParam.deposit_ratio) {
        return callback(new Error('请选择收取比例'))
    }
    if (context.self_form.presaleParam.deposit_type === 1 && !context.self_form.presaleParam.deposit) {
        return callback(new Error('请输入收取金额'))
    }
    callback()
}
const validatePreSaleType = async (rule, value, callback, context) => {
    if (!context.self_form.preSaleType) {
        return callback()
    }
    if (![0,1].includes(context.self_form.presaleParam.pre_sale_type)) {
        return callback(new Error('请选择预售方式'))
    }
    callback()
}
const validateEtd_type = async (rule, value, callback, context) => {
    if (!context.self_form.presaleParam.etd_type && context.self_form.presaleParam.etd_type !== 0) {
        return callback(new Error('请选择发货时间方式'))
    }
    if (context.self_form.presaleParam.etd_type === 0 && !context.self_form.presaleParam.etd_start) {
        return callback(new Error('请选择开始发货日期'))
    }
    if (context.self_form.presaleParam.etd_type === 1 && !context.self_form.presaleParam.etd_days) {
        return callback(new Error('请输入多少天后发货'))
    }
    callback()
}

const validateStockDeductMode = (rule, value, callback) => {
    if (!value && value !== 0) {
        return callback(new Error('请选择库存扣减方式'))
    }
    callback()
}

const validateWeight = (rule, value, callback,context) => {
    if (!value) {
        // return callback(new Error('必填，大于0kg'))
        return callback(new Error('重量必填，请输入0.001-10000'))
    }
    callback()
}



// 若需要vm上下文请用此函数包裹
function contextWrap(fn, context) {
    return (rule, value, callback) => fn(rule, value, callback, context)
}

const RULES = function(context) {
    return {
        itemType: [
            {required: true, message: '必填'}
        ],
        images: [
            {required: true, message: '至少选择1张照片'},
            {validator: contextWrap(validateImages, context)}
        ],
        title: [
            {required: true, message: '请输入商品名称'},
            {validator: validateTitle},
        ],
        summary: [
            {validator: validateSummary},
        ],
        sellPoint: [
            {validator: validateSellPoint},
        ],
        price: [
            {required: true, message: '请输入价格'}
        ],
        quantity: [
            {required: true, message: '请填写库存数'}
        ],
        deliverMethods: [
            {required: true, message: '必填'}
        ],
        itemDesc: [
            {required: true, message: '必填'}
        ],
        pre_sale_range: [
            {required: true, validator: contextWrap(validatePre_sale_range, context)}
        ],
        "presaleParam.deposit_type": [
            {required: true, validator: contextWrap(validateDeposit_type, context)}
        ],
        preSaleType: [
            {validator: contextWrap(validatePreSaleType, context)}
        ],
        "presaleParam.etd_type": [
            {required: true, validator: contextWrap(validateEtd_type, context)}
        ],
        "stockDeductMode": [
            {required: true, validator: validateStockDeductMode}
        ],
        "weight": [
            {required: true, validator: contextWrap(validateWeight, context)}
        ]
    };
} 

const validateSkuStock = (value, prop) => {
    value = String(value).trim();
    const valueNum = Number(value);
    const idx = value.lastIndexOf('.');
    if (value === '') {
        return prop.label + '不能为空值!'
    } else if (isNaN(valueNum)) {
        return prop.label + '必须为大于等于0的整数';
    } else if (idx > -1) {
        return prop.label + '必须为大于等于0的整数';
    } else if (valueNum < 0) {
        return prop.label + '必须为大于等于0的整数';
    } else {
        return false;
    }
}
const validateSkuWeight = (value, prop) => {
    value = String(value).trim();
    const valueNum = Number(value);
    const idx = value.lastIndexOf('.');
    const mStr = value.slice(idx+1);
    if (value === '') {
        return prop.label + '不能为空值!'
    } else if (isNaN(valueNum)) {
        return prop.label + '必须为大于0的数且支持小数点后3位';
    } else if (valueNum < 0.001) {
        return prop.label + '必须为大于0.001kg';
    } else if (idx !== -1 &&  mStr.length > 3) {
        return prop.label + '必须为大于0的数且支持小数点后3位';
    } else {
        return false;
    }
}

export {
    RULES as default,
    validateSkuStock,
    validateSkuWeight
}